import React, { useState } from 'react';
import { BookDetailsPopup, TemplateBook } from './BookDetailsPopup';
export const TemplateGallery = () => {
  const [selectedBook, setSelectedBook] = useState<TemplateBook | null>(null);
  // Preset list of template books
  const templateBooks: TemplateBook[] = [{
    book_id: 'd81b0b04-fde1-4e24-9447-6e6994a6158a',
    title: 'Tofu the Lazy Cat and Cookie the Playful Puppy',
    description: 'Tofu is a naughty cat and he does not want to wake up',
    cover_url: 'https://storybunny.messagesimproved.com/storybunny_pngs/d81b0b04-fde1-4e24-9447-6e6994a6158a_cover.png',
    ageRange: '4-6 years',
    readingLevel: 'Beginner',
    tags: ['Adventure', 'Magic', 'Animals', 'Nature'],
    author: 'Story Bunny Team'
  }, {
    book_id: '19aeac9c-bc57-4557-8229-b640d9e2c33b',
    title: "Timothy's First Day of School",
    description: 'The first day of school is exciting and scary. See how Timothy discovers.',
    cover_url: 'https://storybunny.messagesimproved.com/storybunny_pngs/19aeac9c-bc57-4557-8229-b640d9e2c33b_cover.png',
    ageRange: '5-7 years',
    readingLevel: 'Intermediate',
    tags: ['School', 'Friends', 'Science', 'Friendship'],
    author: 'Story Bunny Team'
  }, {
    book_id: 'ea503033-efc9-4f13-8606-c12bda947169',
    title: 'La Nuit de Francie et Son Lapins',
    description: 'French book about going to bed.',
    cover_url: 'https://storybunny.messagesimproved.com/storybunny_pngs/ea503033-efc9-4f13-8606-c12bda947169_cover.png',
    ageRange: '3-5 years',
    readingLevel: 'Beginner',
    tags: ['Bedtime', 'Adventure', 'Animals', 'Friendship'],
    author: 'Story Bunny Team'
  }, {
    book_id: '95620e7a-cfae-46e3-9ef5-81d1b2960982',
    title: ':(',
    description: "Not everyday can be a happy one. This is a random story that can get your mind off of what's getting you down.",
    cover_url: 'https://storybunny.messagesimproved.com/storybunny_pngs/95620e7a-cfae-46e3-9ef5-81d1b2960982_cover.png',
    ageRange: '2-3 years',
    readingLevel: 'Beginner',
    tags: ['Emotions', 'Friendship', 'Adventure', 'Learning'],
    author: 'Story Bunny Team'
  }, {
    book_id: 'a9b5e396-8165-454d-aaed-58d86ef41bae',
    title: 'The Magical Cars of Rainbow Road',
    description: 'Rainbows and cars',
    cover_url: 'https://storybunny.messagesimproved.com/storybunny_pngs/a9b5e396-8165-454d-aaed-58d86ef41bae_cover.png',
    ageRange: '2-4 years',
    readingLevel: 'Early Reader',
    tags: ['Cars', 'Racing', 'Rainbow', 'Fantasy'],
    author: 'Story Bunny Team'
  }, {
    book_id: 'b62ae0a7-4b1c-4900-8d78-e7be2015e5fb',
    title: 'The Unicorn Who Used The Potty',
    description: 'A Unicorn learns to use the potty and discovers something magical',
    cover_url: 'https://storybunny.messagesimproved.com/storybunny_pngs/b62ae0a7-4b1c-4900-8d78-e7be2015e5fb_cover.png',
    ageRange: '2-4 years',
    readingLevel: 'Early Reader',
    tags: ['Potty', 'Animals', 'Magic', 'New'],
    author: 'Story Bunny Team'
  }];
  const handleBookClick = (book: TemplateBook) => {
    setSelectedBook(book);
  };
  const closePopup = () => {
    setSelectedBook(null);
  };
  return <div data-id="element-1206">
      <h2 className="text-lg md:text-xl font-bold text-[#6B4B3E] mb-3 px-2" data-id="element-1207">
        Remix Templates
      </h2>
      <div className="bg-[#FFF0E6] rounded-lg md:rounded-xl p-4" data-id="element-1208">
        <p className="text-[#6B4B3E]/80 mb-4 text-center" data-id="element-1209">
          Start with a template and customize it to create your own magical
          story!
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-1210">
          {templateBooks.map(book => <div key={book.book_id} className="flex-shrink-0 w-full bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300 cursor-pointer" onClick={() => handleBookClick(book)} data-id="element-1211">
              <div className="aspect-[3/4] relative" data-id="element-1212">
                <img src={book.cover_url} alt={book.title} className="w-full h-full object-cover" onError={e => {
              e.currentTarget.src = '/bunny_face.png';
            }} data-id="element-1213" />
              </div>
              <div className="p-2" data-id="element-1214">
                <h3 className="text-sm font-medium text-[#6B4B3E] line-clamp-2" data-id="element-1215">
                  {book.title}
                </h3>
                <p className="text-xs text-[#6B4B3E]/60 mt-1" data-id="element-1216">
                  {book.ageRange}
                </p>
              </div>
            </div>)}
        </div>
      </div>
      {selectedBook && <BookDetailsPopup book={selectedBook} onClose={closePopup} data-id="element-1217" />}
    </div>;
};